import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { publicRequest } from "../../requestMethods"
import { useDispatch, useSelector } from "react-redux"
import { updateCart, addProduct } from "../../redux/cartRedux"
import { updateUser } from "../../redux/apiCalls"
import { Add, Remove } from "@mui/icons-material"
import { Helmet } from "react-helmet"
// Components
import Footer from "../../components/Footer/Footer"
import Navbar from "../../components/Navbar/Navbar"
import Newsletter from "../../components/Newsletter/Newsletter"
import Button from "../../components/Button/Button"
import ProductImages from "../../components/ProductImages/ProductImages"
import MovingIcon from "../../components/MovingIcon/MovingIcon"
// Styles
import {
   Container,
   Description,
   ImageContainer,
   InfoContainer,
   Title,
   Wrapper,
   Price,
   AddContainer,
   AmountContainer,
   Amount,
   ButtonWrapper,
} from "./Product.styles"
import {
   AttributeContainer,
   Attribute,
   AttributeTitle,
   RoundBorder,
   FilterColor,
   FilterTexture,
   FilterSize,
   DimensionsContainer,
   ImageSize,
   AttributeLabel,
} from "./Product.styles"
import {
   TempleLength,
   LensHeigth,
   LensWidth,
   Nose,
   DistanceBetweenTemples,
} from "./Product.styles"
import { useTheme } from "styled-components"
import Dimensions from "../../images/dimension.png"
import Turtle from "../../images/turtle.jpg"
import yellowGold from "../../images/yellowgold.jpg"
import pinkGold from "../../images/pinkgold.jpg"
import Silver from "../../images/silver.jpg"
import Crystal from "../../images/crystal.jpg"
import Panther from "../../images/panther.jpg"

const Product = () => {
   const location = useLocation()
   const dispatch = useDispatch()
   const theme = useTheme()
   const { t } = useTranslation()
   const productId = location.pathname.split("/")[2]
   const [variationId, setVariationId] = useState(
      location.pathname.split("/")[3],
   )
   const [product, setProduct] = useState({})
   const [variation, setVariation] = useState({})
   const [quantity, setQuantity] = useState(1)
   const [isFavorite, setIsFavorite] = useState(false)
   const [category, setCategory] = useState("optical")
   const cart = useSelector((state) => state.cart)
   const user = useSelector((state) => state.user.currentUser)
   const language = useSelector((state) => state.environment.language)
   const displayPrices = useSelector((state) => state.environment.prices)

   const [isMoving, setIsMoving] = useState(false)
   const startingPoint = document.getElementById("addButton")
   const [endingPoint, setEndingPoint] = useState({ top: 0, left: 0 })

   const browserLocale = navigator.language || navigator.userLanguage
   const isFranceVisitorByLocale = browserLocale === "fr-FR"
   const isFranceUser =
      (user &&
         (user.deliveryCountry === "France" ||
            user.deliveryCountry === "FR")) ||
      isFranceVisitorByLocale

   const shapeTranslation = {
      square: t("productPage.value.shape.square"),
      panto: t("productPage.value.shape.panto"),
      butterfly: t("productPage.value.shape.butterfly"),
      round: t("productPage.value.shape.round"),
      aviator: t("productPage.value.shape.aviator"),
      oval: t("productPage.value.shape.oval"),
      hexagon: t("productPage.value.shape.hexagon"),
   }
   const materialTranslation = {
      acetate: t("productPage.value.material.acetate"),
      metal: t("productPage.value.material.metal"),
      combined: t("productPage.value.material.combined"),
   }

   useEffect(() => {
      window.scrollTo(0, 0)
   }, [variationId])

   useEffect(() => {
      const getProduct = async () => {
         try {
            const res = await publicRequest.get(
               `/products/find/${productId}?collection=true`,
            )
            setProduct(res.data)
            setVariation(
               res.data.variations.find((item) => item._id === variationId),
            )
            setCategory(res.data.categories[0])
         } catch (err) {
            console.log(err)
         }
      }
      getProduct()

      if (user) {
         setIsFavorite(
            user.favoriteProducts.some(
               (favorite) => favorite.variationId === variationId,
            ),
         )
      }
   }, [productId, variationId, user])

   const handleQuantity = (type) => {
      if (type === "dec") {
         quantity > 1 && setQuantity(quantity - 1)
      } else {
         setQuantity(quantity + 1)
      }
   }

   const addToCart = () => {
      if (user) {
         user._id !== cart.userId &&
            dispatch(
               updateCart({
                  userId: user._id,
                  discount: user.discount,
                  deliveryAddress: {
                     name: user.deliveryName,
                     street: user.deliveryStreet,
                     zipCode: user.deliveryZipCode,
                     city: user.deliveryCity,
                     region: user.deliveryRegion,
                     country: user.deliveryCountry,
                     info: user.deliveryInfo,
                  },
               }),
            )
      }
      const unitPrice = product.prices.find(
         (item) => item.userType === (user?.type ? user.type : "public"),
      ).price
      const model = product.title
      const size = product.lensWidth + " - " + product.nose
      const detailedColor = variation.detailedColor.find(
         (item) => item.language === language,
      ).text

      setIsMoving(true)
      setTimeout(() => {
         setIsMoving(false)
         dispatch(
            addProduct({
               ...variation,
               detailedColor,
               model,
               size,
               quantity,
               unitPrice,
               productId,
            }),
         )
      }, 1000)
   }

   const addToFavorites = async () => {
      const model = product.title
      const size = product.lensWidth + " - " + product.nose
      const detailedColor = variation.detailedColor.find(
         (item) => item.language === language,
      ).text

      if (user) {
         let userUpdate = { ...user }
         let favorites = [...user.favoriteProducts]

         if (
            !favorites.some((favorite) => favorite.variationId === variationId)
         ) {
            favorites.push({
               code: variation.code,
               detailedColor: detailedColor,
               ean: variation.ean,
               inventory: variation.inventory,
               outOfCollection: variation.outOfCollection,
               collectionSeason: variation.collectionSeason,
               model: model,
               size: size,
               imageUrl:
                  theme.name === "dark"
                     ? variation.imagesDark[0]
                     : variation.imagesLight[0],
               productId: product._id,
               variationId: variationId,
            })
            userUpdate.favoriteProducts = favorites

            await updateUser(user._id, userUpdate, dispatch, user.accessToken, {
               favoriteProducts: favorites,
            })
         }
      }
   }

   const removeFromFavorites = async () => {
      let userUpdate = { ...user }
      let favorites = [...userUpdate.favoriteProducts]
      userUpdate.favoriteProducts = favorites.filter(
         (item) => item.variationId !== variationId,
      )
      await updateUser(user._id, userUpdate, dispatch, user.accessToken, {
         favoritesProducts: userUpdate.favoriteProducts,
      })
   }

   return (
      <>
         <Helmet>
            <title>{t("productPage.meta.meta_title")}</title>
            <meta name="robots" content="noindex, nofollow" />
         </Helmet>
         <Container>
            {isMoving ? (
               <MovingIcon
                  startTop={
                     startingPoint?.offsetTop + startingPoint?.offsetHeight / 2
                  }
                  startLeft={
                     startingPoint?.offsetLeft + startingPoint?.offsetWidth / 2
                  }
                  endTop={
                     endingPoint.top -
                     (startingPoint?.offsetTop +
                        startingPoint?.offsetHeight / 2)
                  }
                  endLeft={
                     endingPoint.left -
                     (startingPoint?.offsetLeft +
                        startingPoint?.offsetWidth / 2)
                  }
               />
            ) : null}
            <Navbar
               getCartPosition
               setCartPosition={setEndingPoint}
               bgImageColor="light"
            />
            <Wrapper>
               <ImageContainer>
                  <ProductImages
                     images={
                        theme.name === "dark"
                           ? variation.imagesDark
                              ? variation.imagesDark
                              : []
                           : variation.imagesLight
                             ? variation.imagesLight
                             : []
                     }
                  />
               </ImageContainer>
               <InfoContainer>
                  <Title id="title">{product.title}</Title>
                  <Description
                     dangerouslySetInnerHTML={{
                        __html: product.desc
                           ?.find((item) => item.language === language)
                           .text?.replace(/\n/g, "<br />"),
                     }}
                  />
                  <Description>
                     {product?.variations?.[0].detailedColor?.[0].text === "S"
                        ? t("productPage.label.l0")
                        : t("productPage.label.l1")}{" "}
                     :{" "}
                     {
                        variation.detailedColor?.find(
                           (item) => item.language === language,
                        ).text
                     }
                  </Description>
                  <Description>
                     {t("productPage.label.l6")} : {variation.code}
                  </Description>
                  {(category !== "optical" ||
                     user?.type === "optician" ||
                     user?.type === "distributor") &&
                  displayPrices ? (
                     <Price>
                        {
                           product.prices?.find(
                              (item) =>
                                 item.userType ===
                                 (user?.type ? user.type : "public"),
                           ).price
                        }{" "}
                        €
                     </Price>
                  ) : (
                     <></>
                  )}
                  <AttributeContainer>
                     {category !== "accessory" ? (
                        <Attribute>
                           <AttributeTitle>
                              {t("productPage.label.l4")}
                           </AttributeTitle>
                           <AttributeLabel>
                              {materialTranslation[product.material]}
                           </AttributeLabel>
                        </Attribute>
                     ) : (
                        <></>
                     )}
                     <Attribute>
                        <AttributeTitle>
                           {product?.variations?.[0].detailedColor?.[0].text ===
                           "S"
                              ? t("productPage.label.l7")
                              : t("productPage.label.l5")}
                        </AttributeTitle>
                        {product.variations?.map((item) => {
                           const textures = [
                              "turtle",
                              "goldyellow",
                              "goldpink",
                              "silver",
                              "crystal",
                              "panther",
                              "ruthenium",
                           ]
                           let texture
                           let color1
                           let color2
                           if (textures.includes(item.mainColor)) {
                              texture = item.mainColor
                              color1 = "transparent"
                              color2 = item.secondColor
                                 .replace("goldyellow", "yellow")
                                 .replace("goldpink", "pink")
                                 .replace("silver", "grey")
                                 .replace("turtle", "brown")
                                 .replace("crystal", "white")
                                 .replace("panther", "brown")
                                 .replace("ruthenium", "grey")
                           } else if (textures.includes(item.secondColor)) {
                              texture = item.secondColor
                              color1 = "transparent"
                              color2 = item.mainColor
                           } else {
                              texture = ""
                              color1 = item.mainColor
                              color2 = item.secondColor
                           }

                           let selected
                           if (item._id === variationId) {
                              selected = "primary"
                           } else {
                              selected = "secondary"
                           }
                           return (
                              <RoundBorder
                                 key={item._id}
                                 onClick={() => setVariationId(item._id)}
                                 selected={selected}
                              >
                                 <FilterTexture
                                    texture={
                                       texture === "turtle"
                                          ? Turtle
                                          : texture === "goldyellow"
                                            ? yellowGold
                                            : texture === "goldpink"
                                              ? pinkGold
                                              : texture === "silver"
                                                ? Silver
                                                : texture === "ruthenium"
                                                  ? Silver
                                                  : texture === "crystal"
                                                    ? Crystal
                                                    : texture === "panther"
                                                      ? Panther
                                                      : null
                                    }
                                 >
                                    <FilterColor
                                       color1={color1}
                                       color2={color2}
                                    >
                                       {product?.variations?.[0]
                                          .detailedColor?.[0].text === "S" ? (
                                          <FilterSize>
                                             {item.detailedColor[0].text}
                                          </FilterSize>
                                       ) : (
                                          <></>
                                       )}
                                    </FilterColor>
                                 </FilterTexture>
                              </RoundBorder>
                           )
                        })}
                     </Attribute>
                  </AttributeContainer>
                  {category !== "accessory" ? (
                     <AttributeContainer>
                        <Attribute>
                           <AttributeTitle>
                              {t("productPage.label.l2")}
                           </AttributeTitle>
                           <AttributeLabel>
                              {shapeTranslation[product.shape]}
                           </AttributeLabel>
                        </Attribute>
                        <Attribute>
                           <AttributeTitle>
                              {t("productPage.label.l3")}
                           </AttributeTitle>
                           <DimensionsContainer>
                              <ImageSize src={Dimensions} filter={100} />
                              <TempleLength>
                                 {product.templeLength}
                              </TempleLength>
                              <LensHeigth>{product.lensHeight}</LensHeigth>
                              <LensWidth>{product.lensWidth}</LensWidth>
                              <Nose>{product.nose}</Nose>
                              <DistanceBetweenTemples>
                                 {product.totalWidth}
                              </DistanceBetweenTemples>
                           </DimensionsContainer>
                        </Attribute>
                     </AttributeContainer>
                  ) : (
                     <></>
                  )}
                  {(category === "accessory" && isFranceUser) ||
                  user?.type === "optician" ||
                  user?.type === "distributor" ? (
                     <AddContainer>
                        <AmountContainer>
                           <Remove
                              color="primary"
                              fontSize="large"
                              onClick={() => handleQuantity("dec")}
                              style={{ cursor: "pointer" }}
                           />
                           <Amount>{quantity}</Amount>
                           <Add
                              color="primary"
                              fontSize="large"
                              onClick={() => handleQuantity("inc")}
                              style={{ cursor: "pointer" }}
                           />
                        </AmountContainer>
                        <ButtonWrapper id="addButton">
                           <Button
                              text={t("productPage.button.b1")}
                              callback={() => addToCart()}
                              width={90}
                           />
                        </ButtonWrapper>
                        <ButtonWrapper>
                           {isFavorite ? (
                              <Button
                                 text={t("productPage.button.b3")}
                                 callback={() => removeFromFavorites()}
                                 disabled={!user}
                                 width={90}
                              />
                           ) : (
                              <Button
                                 text={t("productPage.button.b2")}
                                 callback={() => addToFavorites()}
                                 disabled={!user}
                                 width={90}
                              />
                           )}
                        </ButtonWrapper>
                     </AddContainer>
                  ) : (
                     <></>
                  )}
               </InfoContainer>
            </Wrapper>
            <Newsletter />
            <Footer />
         </Container>
      </>
   )
}

export default Product
